import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import HomeAbout from "../ones/HomeAbout";
import HomeServices from "./HomeServices";
import Footer from "../ones/Footer";
import CallToAction from "../ones/CallToAction";
import HomeTeam from "./HomeTeam";
import WhyChooseUs from "./WhyChooseUs";

export default function HomeLanding() {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <HomeBanner1 />
        <HomeAbout />
        <HomeTeam />
        <HomeServices />
        <WhyChooseUs />
        <CallToAction />
        <Footer />
      </>
    );
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
